import React from 'react';
import { Icon } from './Icon.js';
export const IconPin = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M11.9966 17L11.9966 22", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M21 17H3L3 13L6 12L7 3H17L18 12L21 13V17Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", fill: "none" })));
};
//# sourceMappingURL=IconPin.js.map